Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessReviewParser
  parse: (reviewJson) ->
    builder = new Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessReviewBuilder()
    builder.setText(reviewJson.text)
    builder.setCreatedAt(new Date(reviewJson.created_at * 1000))
    builder.setContentId(reviewJson.content_id)
    builder.setReviewId(reviewJson.review_id)
    builder.setStarRating(reviewJson.star_rating)
    builder.build()
